<div class="section cta">
  <div class="container">
    <div class="row">
      <div class="col-sm-12 col-md-12">
        <div class="cta-info">
          <h3>
            {{'GB_Registration_CallToActionTitle' | translate}}
          </h3>

          <p [innerHTML]="'GB_Registration_CallToActionDescription' | translate"></p>

          <a [routerLink]="['/register']" matTooltip="{{'GB_Registration_RegisterNow' | translate}}" class="btn btn-cta">
            {{'GB_Registration_RegisterNow' | translate}}
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
